<template>
    <div class="events-filter">
        <div class="events-filter-header">
            <div class="events-filter-title-text events-filter-title">
                Фильтры
            </div>
            <!-- <div class="events-filter-all events-filter-link">
                Все
            </div> -->
        </div>
        <div class="events-filter-checkbox">
            <event-check labelText="Конференция" @clickCheckbox="conferenceClick"/>
            <event-check labelText="Семинар" @clickCheckbox="seminarClick"/>
            <event-check labelText="Журнал" @clickCheckbox="logClick"/>
            <event-check labelText="Другое" @clickCheckbox="anotherClick"/>
        </div>
    </div>
</template>

<script>

import EventCheck from '@/components/eventsFilter/EventCheck.vue'
import { useEventsStore } from '@/store/events'

export default {
    name: 'EventsFilter',
    components: {
        EventCheck
    },
    data(){
        let filters = ['Конференция', 'Семинар', 'Журнал', 'Другое']
        return {
            'filters': filters
        }
    },
    methods: {
        conferenceClick(value){
            const eventsStore = useEventsStore()
            if (value == true)
              this.filters.push('Конференция')
            else
              this.filters = this.filters.filter((el)=>el!='Конференция')
            eventsStore.setChosenFilters(this.filters)
        },
        seminarClick(value){
            const eventsStore = useEventsStore()
            if (value == true)
              this.filters.push('Семинар')
            else
              this.filters = this.filters.filter((el)=>el!='Семинар')
            eventsStore.setChosenFilters(this.filters)

        },
        logClick(value){
            const eventsStore = useEventsStore()
            if (value == true)
              this.filters.push('Журнал')
            else
              this.filters = this.filters.filter((el)=>el!='Журнал')
            eventsStore.setChosenFilters(this.filters)
        },
        anotherClick(value){
            const eventsStore = useEventsStore()
            if (value == true)
              this.filters.push('Другое')
            else
              this.filters = this.filters.filter((el)=>el!='Другое')
            eventsStore.setChosenFilters(this.filters)
        }
    }
}
</script>